import { useDesignConfig } from '../../config/design.context';

export const useHasGlobalBackButton = () => {
  const design = useDesignConfig();
  return design?.components?.BackButton?.enabled;
};
